<div class="activation-container" nz-row>
  @if (!isPhonePortrait) {
    <div nz-col nzSpan="7">
      <img nz-image nzSrc="/public/assets/images/login_family.png" alt="" class="full-img-height" />
    </div>
  }
  @if (isPhonePortrait) {
    <div nz-col [style]="isPhonePortrait ? 'padding: 20px; background-color: #F7F7F7;' : 'padding: 80px 50px; background-color: #F7F7F7;'">
      <nz-steps appNonFocusableSteps [nzCurrent]="current" [nzDirection]="isPhonePortrait ? 'horizontal' : 'vertical'">
        <nz-step nzTitle="{{ 'activation.name' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.fiscalCode' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.contactDetails' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.residence' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.privacy' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.useCondition' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
      </nz-steps>
    </div>
  } @else {
    <div class="stepper" nz-col [nzXl]="4" [style]="isPhonePortrait ? 'padding: 20px; background-color: #F7F7F7;' : 'padding: 48px 0 10px 48px; background-color: #F7F7F7;'">
      <nz-steps appNonFocusableSteps [nzCurrent]="current" [nzDirection]="isPhonePortrait ? 'horizontal' : 'vertical'">
        <nz-step nzTitle="{{ 'activation.name' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.fiscalCode' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.contactDetails' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.residence' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.privacy' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
        <nz-step nzTitle="{{ 'activation.useCondition' | translate }}" [class]="isPhonePortrait ? '' : 'enum-padding'"></nz-step>
      </nz-steps>
    </div>
  }

  <div
    nz-col
    [ngClass]="{ 'activation-second': (current > 2 || current === 2) && current !== 4, 'activation-first': current !== 2 && current < 2, 'activation-privacy': current === 4 }"
    [nzSpan]="isPhonePortrait ? '24' : !current || (current > 0 && current < 10) ? '12' : '17'"
  >
    <nz-layout>
      <nz-content class="inner-content" nz-flex nzJustify="center">
        <div nz-row>
          <div nz-col nzSpan="24">
            <div [class]="isPhonePortrait ? '' : 'steps-content'">
              <form nz-form [formGroup]="validateForm" class="login-form">
                @if (current == 0) {
                  <h2 nz-typography>{{ 'activation.completeInformation' | translate }}</h2>
                  <p nz-typography style="margin-bottom: 3em">{{ 'activation.subtitle3' | translate }}</p>
                  <div class="container-inputs">
                    <ds-input-text
                      [class.readonly-like]="readonlyFields['name']"
                      [control]="validateForm.get('name')"
                      [placeholder]="'Mario'"
                      [label]="'activation.name' | translate"
                    ></ds-input-text>
                    <ds-input-text
                      [class.readonly-like]="readonlyFields['surname']"
                      [control]="validateForm.get('surname')"
                      [placeholder]="'Rossi'"
                      [label]="'activation.surname' | translate"
                    ></ds-input-text>
                  </div>
                }
                @if (current == 1) {
                  <h2 nz-typography>{{ 'activation.completeInformation' | translate }}</h2>
                  <p nz-typography style="margin-bottom: 3em">{{ 'activation.subtitle2' | translate }}</p>
                  <label class="checkbox" nz-checkbox formControlName="calculateTaxcode"
                    aria-label="Calcola il codice fiscale automaticamente">
                    {{ 'createProfileModal.want_calculate_taxcode' | translate }}
                  </label>
                  @if (validateForm.get('calculateTaxcode')?.value) {
                    <div class="input-taxcode-container" [formGroupName]="'taxcodeSection'">
                      <p>{{ 'createProfileModal.complete_for_taxcode' | translate }}</p>
                      <div nz-row nzGutter="16">
                        <ds-select
                          style="margin-right: 3px"
                          nz-col
                          class="input-select-container"
                          [nzXl]="12"
                          [nzLg]="24"
                          [nzXs]="24"
                          [nzMd]="24"
                          [placeholder]="'createProfileModal.select' | translate"
                          [label]="'createProfileModal.gender' | translate"
                          [texts]="['M', 'F']"
                          [values]="['M', 'F']"
                          [control]="validateForm.get('taxcodeSection.gender')"
                        ></ds-select>
                        <div class="datepicker" nz-col [nzLg]="24" [nzXs]="24" [nzMd]="24">
                          <span>Data di nascita</span>
                          <ds-datepicker
                            style="margin-right: 3px"
                            class="input-select-container"
                            [control]="validateForm.get('taxcodeSection.birthDate')"
                            [placeholder]="'01/01/1970'"
                            [startDate]="datepicker.control"
                            [endDate]="datepicker.endControl"
                          ></ds-datepicker>
                        </div>
                        <ds-select
                          nz-col
                          class="input-select-container"
                          [nzXl]="12"
                          [nzLg]="24"
                          [nzXs]="24"
                          [nzMd]="24"
                          [placeholder]="'createProfileModal.select' | translate"
                          [label]="'createProfileModal.district' | translate"
                          [valuesAndTexts]="districtsTaxcode"
                          [control]="validateForm.get('taxcodeSection.birthDistrict')"
                        ></ds-select>
                        <ds-select
                          nz-col
                          class="input-select-container"
                          [nzXl]="12"
                          [nzLg]="24"
                          [nzXs]="24"
                          [nzMd]="24"
                          [placeholder]="'createProfileModal.select' | translate"
                          [label]="'createProfileModal.cities' | translate"
                          [valuesAndTexts]="citiesTaxcode"
                          [control]="validateForm.get('taxcodeSection.birthCity')"
                        ></ds-select>
                      </div>
                      @if (validateForm.get('taxcode')?.valid && validateForm.get('taxcode')?.value) {
                        <div class="info-message">
                          <img src="/public/assets/images/check-circle-green.svg" alt="check circle green" />
                          <div>
                            <span>{{ 'createProfileModal.your_taxcode_is' | translate }}</span>
                            <span style="font-weight: 600">{{ validateForm.get('taxcode')?.value }}</span>
                            <span>{{ 'createProfileModal.and_auto_completes_in_field' | translate }}</span>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <nz-form-item>
                    <nz-form-control [class.readonly-like]="readonlyFields['fiscalCode']" nzErrorTip="{{ 'activation.invalidFiscalCode' | translate }}">
                      <nz-form-label [nzSpan]="6" nzFor="fiscalCode" style="overflow: visible">{{ 'activation.fiscalCode' | translate }}</nz-form-label>
                      <nz-input-group>
                        <input type="text" nz-input nzSize="large" formControlName="fiscalCode" placeholder="Es. BNCMRA70L130653Z" />
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                }
                @if (current == 2) {
                  <h2 nz-typography>{{ 'activation.completeInformation' | translate }}</h2>
                  <p nz-typography style="margin-bottom: 3em">{{ 'activation.subtitle3' | translate }}</p>
                  <nz-form-item>
                    <nz-form-control [class.readonly-like]="readonlyFields['email']" nzErrorTip="{{ 'activation.invalidEmail' | translate }}">
                      <nz-form-label [nzSpan]="6" nzFor="email">{{ 'activation.email' | translate }}</nz-form-label>
                      <nz-input-group>
                        <input type="text" nz-input nzSize="large" formControlName="email" placeholder="esempio@myclinic.com" />
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-control [class.readonly-like]="readonlyFields['phoneNumber']" nzErrorTip="{{ 'activation.invalidPhoneNumber' | translate }}">
                      <nz-form-label [nzSpan]="6" nzFor="phoneNumber" style="overflow: visible">{{ 'activation.phoneNumber' | translate }}</nz-form-label>
                      <nz-input-group>
                        <input type="text" nz-input nzSize="large" formControlName="phoneNumber" placeholder="342 740 0877" />
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                }
                @if (current == 3) {
                  <h2 nz-typography>{{ 'activation.completeInformation' | translate }}</h2>
                  <p nz-typography style="margin-bottom: 3em">{{ 'activation.subtitle3' | translate }}</p>
                  <nz-form-item>
                    <nz-form-control nzErrorTip="{{ 'activation.invalidNation' | translate }}">
                      <nz-form-label [nzSpan]="6" nzFor="nation" style="overflow: visible">{{ 'activation.nation' | translate }}</nz-form-label>
                      <nz-input-group [class.readonly-like]="readonlyFields['nation']">
                        <nz-select formControlName="nation" zShowSearch nzAllowClear nzSize="large" nzAccessible aria-label="Seleziona la nazione di residenza" placeholder="Es. Italia" (ngModelChange)="fillDistricts()">
                          @for (country of countries; track country) {
                            <nz-option [nzValue]="country.code" [nzLabel]="country.description"></nz-option>
                          }
                        </nz-select>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                  <div nz-row [nzGutter]="24">
                    <div nz-col [nzSpan]="6">
                      <nz-form-item>
                        <nz-form-control [class.readonly-like]="readonlyFields['province']" nzErrorTip="{{ 'activation.invalidProvince' | translate }}">
                          <nz-form-label [nzSpan]="6" nzFor="province" style="overflow: visible">{{ 'activation.province' | translate }}</nz-form-label>
                          <nz-input-group>
                            <nz-select formControlName="province" zShowSearch nzAllowClear nzSize="large" nzAccessible aria-label="Seleziona la provincia di residenza" placeholder="Es. VR" (ngModelChange)="fillCities()">
                              @for (district of districts; track district) {
                                <nz-option [nzValue]="district.code" [nzLabel]="district.code"></nz-option>
                              }
                            </nz-select>
                          </nz-input-group>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="18">
                      <nz-form-item>
                        <nz-form-control [class.readonly-like]="readonlyFields['city']" nzErrorTip="{{ 'activation.invalidCity' | translate }}">
                          <nz-form-label [nzSpan]="6" nzFor="city" style="overflow: visible">{{ 'activation.city' | translate }}</nz-form-label>
                          <nz-input-group>
                            <nz-select formControlName="city" zShowSearch nzAllowClear nzSize="large" nzAccessible aria-label="Seleziona la città di residenza" placeholder="Es. Verona">
                              @for (city of cities; track cities) {
                                <nz-option [nzValue]="city.code" [nzLabel]="city.description"></nz-option>
                              }
                            </nz-select>
                          </nz-input-group>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                  </div>
                  <nz-form-item>
                    <nz-form-control [class.readonly-like]="readonlyFields['cap']" nzErrorTip="{{ 'activation.invalidCap' | translate }}">
                      <nz-form-label [nzSpan]="6" nzFor="cap" style="overflow: visible">{{ 'activation.cap' | translate }}</nz-form-label>
                      <nz-input-group>
                        <input type="text" nz-input nzSize="large" formControlName="cap" placeholder="ES. 80029" />
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                  <div nz-row [nzGutter]="24">
                    <div nz-col [nzSpan]="12">
                      <nz-form-item>
                        <nz-form-control [class.readonly-like]="readonlyFields['address']" nzErrorTip="{{ 'activation.invalidAddress' | translate }}">
                          <nz-form-label [nzSpan]="6" nzFor="address" style="overflow: visible">{{ 'activation.address' | translate }}</nz-form-label>
                          <nz-input-group>
                            <input type="text" nz-input nzSize="large" formControlName="address" placeholder="Es. VIA ALCANO" />
                          </nz-input-group>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    @if (origin !== '"activation"' && origin !== '"login"') {
                      <div nz-col [nzSpan]="12">
                        <nz-form-item>
                          <nz-form-control [class.readonly-like]="readonlyFields['houseNumber']" nzErrorTip="{{ 'activation.invalidHouseNumber' | translate }}">
                            <nz-form-label [nzSpan]="6" nzFor="houseNumber" style="overflow: visible">{{ 'activation.houseNumber' | translate }}</nz-form-label>
                            <nz-input-group>
                              <input type="number" nz-input nzSize="large" formControlName="houseNumber" placeholder="40" />
                            </nz-input-group>
                          </nz-form-control>
                        </nz-form-item>
                      </div>
                    }
                  </div>
                }
                @if (current == 4) {
                  <h2 nz-typography>{{ 'activation.acceptPrivacy' | translate }}</h2>
                  <p nz-typography style="margin-bottom: 3em">{{ 'activation.subtitle4' | translate }}</p>

                  <h5 nz-typography style="margin-bottom: 3em">{{ 'activation.subtitle4_1' | translate }}</h5>
                  <nz-form-item>
                    <nz-form-control nzErrorTip="{{ 'activation.invalidRadios' | translate }}">
                      <nz-radio-group formControlName="radio1" role="radiogroup" aria-label="Consenso per uso dati personali">
                        <label nz-radio nzValue="true" aria-label="Acconsento all'uso dei miei dati personali">{{ 'activation.giveConsens' | translate }}</label>
                        <label nz-radio nzValue="false" aria-label="Non acconsento all'uso dei miei dati personali">{{ 'activation.notGiveConsens' | translate }}</label>
                      </nz-radio-group>
                    </nz-form-control>
                    <p nz-typography style="margin-top: 1em">
                      {{ 'activation.to' | translate }}
                      <strong>{{ 'activation.europAssistanceItalia' | translate }}</strong>
                      {{ 'activation.radioDescription' | translate }}
                    </p>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-control nzErrorTip="{{ 'activation.invalidRadios' | translate }}">
                      <nz-radio-group formControlName="radio2" role="radiogroup" aria-label="Consenso per dati di Redion">
                        <label nz-radio nzValue="true" aria-label="Acconsento per Redion Italia">{{ 'activation.giveConsens' | translate }}</label>
                        <label nz-radio nzValue="false" aria-label="Non acconsento per Redion Italia">{{ 'activation.notGiveConsens' | translate }}</label>
                      </nz-radio-group>
                    </nz-form-control>
                    <p nz-typography style="margin-top: 1em">
                      {{ 'activation.to' | translate }}
                      <strong>{{ 'activation.europAssistanceItalia' | translate }}</strong>
                      {{ 'activation.radioDescription2' | translate }}
                    </p>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-control nzErrorTip="{{ 'activation.invalidRadios' | translate }}">
                      <nz-radio-group formControlName="radio3" role="radiogroup" aria-label="Consenso per comunicazioni commerciali">
                        <label nz-radio nzValue="true" aria-label="Acconsento alle comunicazioni commerciali">{{ 'activation.giveConsens' | translate }}</label>
                        <label nz-radio nzValue="false" aria-label="Non acconsento alle comunicazioni commerciali">{{ 'activation.notGiveConsens' | translate }}</label>
                      </nz-radio-group>
                    </nz-form-control>
                    <p nz-typography style="margin-top: 1em">
                      {{ 'activation.to' | translate }}
                      <strong>{{ 'activation.europAssistanceItalia' | translate }}</strong>
                      {{ 'activation.radioDescription3' | translate }}
                    </p>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-control nzErrorTip="{{ 'activation.invalidRadios' | translate }}">
                      <nz-radio-group formControlName="radio4" role="radiogroup" aria-label="Consenso per partner terzi">
                        <label nz-radio nzValue="true" aria-label="Acconsento alla comunicazione ai partner">{{ 'activation.giveConsens' | translate }}</label>
                        <label nz-radio nzValue="false" aria-label="Non acconsento alla comunicazione ai partner">{{ 'activation.notGiveConsens' | translate }}</label>
                      </nz-radio-group>
                    </nz-form-control>
                    <p nz-typography style="margin-top: 1em">
                      {{ 'activation.to' | translate }}
                      <strong>{{ 'activation.europAssistanceItalia' | translate }}</strong>
                      {{ 'activation.radioDescription4' | translate }}
                    </p>
                  </nz-form-item>

                  <p nz-typography style="margin-top: 3em; margin-bottom: 3em">
                    {{ 'activation.iRead' | translate }}
                    <a class="termsAndConditions"
                      ><u
                        ><strong>{{ 'activation.dataTraitments' | translate }}</strong></u
                      ></a
                    >
                    {{ 'activation.subtitle4_2' | translate }}
                  </p>
                }
                @if (current == 5) {
                  <h2 nz-typography>{{ 'activation.lastStep' | translate }}</h2>
                  <p nz-typography style="margin-bottom: 3em">{{ 'activation.subtitle5' | translate }}</p>
                  <nz-form-item>
                    <nz-form-control nzErrorTip="{{ 'activation.invalidTermsAndRadioCondition' | translate }}">
                      <label nz-radio formControlName="radioTerms">
                        {{ 'activation.termsAndRadioCondition' | translate }}
                        <a
                          ><u
                            ><strong>{{ 'activation.useCondition' | translate }}</strong></u
                          ></a
                        >
                      </label>
                    </nz-form-control>
                  </nz-form-item>
                }
              </form>

              <!-- BUTTONS FORM -->
              <div [ngClass]="{ 'first-step-btn': current === 0, 'other-step-btn': current !== 0 }">
                <div nz-row [ngClass]="{ '': current === 0, 'row-btn': current !== 0 }">
                  @if (current !== 0) {
                    <div nz-col>
                      <ds-button [text]="'buttons.goBack' | translate" [iconLeft]="'/public/assets/images/activation-arrow-back.svg'" [width]="'small'" [styleType]="'empty-main'" ariaLabel="Torna al passaggio precedente" class="text-uppercase" (click)="back()"></ds-button>
                    </div>
                  }
                  <div nz-col>
                    <ds-button [text]="'buttons.proceed' | translate" [iconRight]="'/public/assets/images/activation_arrow.svg'" [width]="'small'" [isDisabled]="checkDisabledState(current)" ariaLabel="Procedi al passaggio successivo" class="ant-btn theme-color text-uppercase" (click)="next(current)"></ds-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="terms">
              <div class="termsAndConditionsSection">
                {{ 'login.moreInfo' | translate }}
                <a [routerLink]="['/terms-activation']" class="termsAndConditions">
                  <u>
                    <strong>{{ 'login.useCondition' | translate }}</strong>
                  </u>
                </a>
                {{ 'login.and' | translate }}
                <a role="button" tabindex="0" (click)="goToLink()" (keydown.enter)="goToLink()" (keydown.space)="goToLink(); $event.preventDefault()" class="termsAndConditions">
                  <u>
                    <strong>{{ 'login.dataTraitments' | translate }}</strong>
                  </u>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nz-content>
    </nz-layout>
  </div>
</div>
